import React, { useState, useContext } from "react";
// import { Link as ReactScrollLink } from "react-scroll";
import { Link } from "gatsby";

import default_logo from "../images/logo.png";
import SiteMetaContext from "../../../contexts/SiteMetaContext";
import { templateVariableValue } from "../../../helpers/templateVariables";
import {
  getTranslatedValue,
  getTranslatedLink,
  translateStatic,
} from "../../../helpers/translationHelper";
import { formatLink } from "../../../helpers/helper";
import ContactFormContainer from "../../../common/ContactFormContainer";
import * as theme5Styles from "../scss/theme5.module.scss";

import dnarrow from "../images/down-arrow-black.svg";
import close from "../images/close.png";

function Header() {
  const [isExpanded, toggleExpansion] = useState(false);
  const [isShowLang, toggleLang] = useState(false);
  // const [isShowCurrency, toggleCurrency] = useState(false);
  const siteData = useContext(SiteMetaContext);
  const [isShowModal, toggleModal] = useState(false);
  const [isSubMenu, toggleSubMenu] = useState(false);
  const [menuIndex, setMenuIndex] = useState(null);

  const handleSubMenu = (menu_id) => {
    if (menu_id == menuIndex) {
      toggleSubMenu(!isSubMenu);
    } else {
      toggleSubMenu(true);
      setMenuIndex(menu_id);
    }
  };

  const {
    remarso: {
      domainByURL: {
        website: {
          company: { logo: company_logo },
          logo,
          menus,
          setting: display_settings,
          templateConfiguration,
          template: { templateVariables },
        },
      },
    },
    location,
    locales,
    currentLocale,
    currentLocaleKey,
    defaultLocaleKey,
  } = siteData;

  const headerLogo = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "logo-header",
    currentLocaleKey,
    defaultLocaleKey
  );
  const showLogo = headerLogo || logo || company_logo || default_logo;

  const {
    display_company_logo,
    display_menu,
    display_contact_form,
  } = display_settings;

  return (
    <header className={`${theme5Styles.mainHeader}`}>
      <div className={theme5Styles.wrapper}>
        <div className={`flex justify-between`}>
          {(() => {
            if (display_company_logo) {
              return (
                <Link to={getTranslatedLink("/", currentLocaleKey)}>
                  <h1 className={`flex items-center text-white no-underline`}>
                    <img
                      alt="logo"
                      className={theme5Styles.logo}
                      src={showLogo}
                    />
                  </h1>
                </Link>
              );
            }
          })()}
          <div className={`${theme5Styles.headerRight}`}>
            <nav
              className={`${theme5Styles.navC} ${
                isExpanded ? `${theme5Styles.showNow}` : ` `
              }`}
            >
              <div className={`${theme5Styles.navBx}`}>
                <ul>
                  {(() => {
                    if (display_menu) {
                      return menus.map((menu) => {
                        if (menu.children.length > 0) {
                          return (
                            <li
                              className={`${theme5Styles.subNav}`}
                              key={menu.id}
                            >
                              <a>
                                {getTranslatedValue(
                                  menu.translations,
                                  "name",
                                  currentLocaleKey,
                                  defaultLocaleKey
                                )}
                              </a>
                              <span
                                onClick={() => handleSubMenu(menu.id)}
                                className={`${
                                  isSubMenu && menuIndex == menu.id
                                    ? `${theme5Styles.open}`
                                    : ` `
                                } ${theme5Styles.subClick}`}
                              ></span>
                              <ul
                                className={`${
                                  isSubMenu && menuIndex == menu.id
                                    ? `${theme5Styles.open}`
                                    : ` `
                                }`}
                              >
                                {menu.children.map((child) => {
                                  let link = getTranslatedValue(
                                    child.translations,
                                    "link",
                                    currentLocaleKey,
                                    defaultLocaleKey
                                  );
                                  if (link) {
                                    return (
                                      <li key={child.id}>
                                        <Link to={formatLink(link)}>
                                          {getTranslatedValue(
                                            child.translations,
                                            "name",
                                            currentLocaleKey,
                                            defaultLocaleKey
                                          )}
                                        </Link>
                                      </li>
                                    );
                                  }
                                })}
                              </ul>
                            </li>
                          );
                        } else {
                          let link = getTranslatedValue(
                            menu.translations,
                            "link",
                            currentLocaleKey,
                            defaultLocaleKey
                          );
                          if (link) {
                            return (
                              <li key={menu.id}>
                                <Link to={formatLink(link)}>
                                  {getTranslatedValue(
                                    menu.translations,
                                    "name",
                                    currentLocaleKey,
                                    defaultLocaleKey
                                  )}
                                </Link>
                              </li>
                            );
                          }
                        }
                      });
                    }
                  })()}
                  {(() => {
                    if (display_contact_form) {
                      return (
                        <li>
                          <a
                            className={`${theme5Styles.btn}`}
                            onClick={() => toggleModal(!isShowModal)}
                          >
                            {translateStatic(
                              "contact",
                              currentLocaleKey,
                              defaultLocaleKey
                            )}
                          </a>
                        </li>
                      );
                    }
                  })()}
                </ul>
                <div
                  className={`${theme5Styles.contactModal} ${
                    isShowModal ? `${theme5Styles.show}` : ` `
                  }`}
                >
                  <div className={`${theme5Styles.contactUs}`}>
                    <span
                      onClick={() => toggleModal(!isShowModal)}
                      className={theme5Styles.close}
                    >
                      <img alt="close" src={close} />
                    </span>
                    <h6>
                      {translateStatic(
                        "contact_us",
                        currentLocaleKey,
                        defaultLocaleKey
                      )}
                      <small>
                        {translateStatic(
                          "contact_form_text",
                          currentLocaleKey,
                          defaultLocaleKey
                        )}
                      </small>
                    </h6>
                    <ContactFormContainer />
                  </div>
                </div>
              </div>
            </nav>
            <div
              className={`${isShowLang ? `${theme5Styles.open}` : ` `} ${
                theme5Styles.headDropdown
              }`}
            >
              <div
                className={`${theme5Styles.txt}`}
                onClick={() => toggleLang(!isShowLang)}
              >
                <span className={theme5Styles.sel}>
                  <img
                    alt=""
                    src={require(`../images/flags/${
                      currentLocaleKey == "en" ? "us" : currentLocaleKey
                    }.svg`).default}
                  />
                  {currentLocale?.name}
                </span>
                <span className={theme5Styles.arrow}>
                  <img alt="" src={dnarrow} />
                </span>
              </div>
              <ul>
                {locales.map(({ name, language_key }) => {
                  return (
                    <li key={language_key}>
                      <Link
                        to={getTranslatedLink(location.pathname, language_key)}
                      >
                        <img
                          alt=""
                          src={require(`../images/flags/${
                            language_key == "en" ? "us" : language_key
                          }.svg`).default}
                        />{" "}
                        {name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <button
              className={`${theme5Styles.mobileNavBar} flex items-center block px-3 py-2 ml-3 md:ml-6 text-white border border-white rounded md:hidden`}
              onClick={() => toggleExpansion(!isExpanded)}
            >
              <svg
                className={`w-3 h-3 fill-current`}
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
              </svg>
            </button>
            <div
              className={`${isExpanded ? `${theme5Styles.showNow}` : ` `} ${
                theme5Styles.navOverlay
              }`}
              onClick={() => toggleExpansion(!isExpanded)}
            >
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
